module.exports = __webpack_public_path__ + "static/assets/0653ebcc14db25f4f0e5149fe46e5d8d.jpg";